const DASHBOARD_UUID = 'dash-1';

const DASHBOARD_LIST = [
  {
    dashboard_uuid: DASHBOARD_UUID,
    name: 'Main dashboard',
    is_default: true,
    is_user_default: false,
  },
];

const DASHBOARD_LAYOUT = {
  data: {
    dashboard_uuid: DASHBOARD_UUID,
    name: 'Demo dashboard',
    version: '1',
    filters: [],
    widgets: [
      {
        instance_uuid: 'w1-notes-0001',
        widget_definition_uuid: 'd1-notes-def',
        widget_type: 'CUSTOM_FIXED',
        accepts_global_filters: true,
        layout: { x: 0, y: 0, w: 4, h: 7 },
        constraints: { minH: 7, maxH: 9, minW: 4, maxW: 8 },
        config: {
          card: {
            title: 'Notes',
            description: 'Notes list',
            header_buttons: [
              {
                key: 'create',
                iconKey: 'Plus',
                tooltip: 'Create',
                action: { type: 'NAVIGATE', target: '/activity/new-note' },
              },
            ],
          },
        },
      },
      {
        instance_uuid: 'w2-activity-0001',
        widget_definition_uuid: 'd2-activity-def',
        widget_type: 'CUSTOM_FIXED',
        accepts_global_filters: true,
        layout: { x: 4, y: 0, w: 8, h: 7 },
        constraints: { minH: 7, maxH: 9, minW: 4, maxW: 8 },
        config: {
          card: {
            title: 'Activity Feed',
            description: '',
            header_buttons: [],
          },
        },
      },
      {
        instance_uuid: 'w3-standard-0001',
        widget_definition_uuid: 'd3-standard-def',
        widget_type: 'STANDARD',
        accepts_global_filters: true,
        layout: { x: 0, y: 7, w: 6, h: 7 },
        constraints: { minH: 7, maxH: 9, minW: 4, maxW: 8 },
        config: {
          card: {
            title: 'Emails',
            description: '',
            header_buttons: [],
          },
        },
      },
      {
        instance_uuid: 'w4-standard-0002',
        widget_definition_uuid: 'd4-standard-def',
        widget_type: 'STANDARD',
        accepts_global_filters: true,
        layout: { x: 6, y: 7, w: 6, h: 7 },
        constraints: { minH: 7, maxH: 9, minW: 4, maxW: 8 },
        config: {
          card: {
            title: 'Tasks',
            description: '',
            header_buttons: [],
          },
        },
      },
    ],
  },
};

export const fetchDashboardList = async () => {
  return { data: DASHBOARD_LIST };
};

export const fetchDashboardLayout = async (dashboardUuid, options = {}) => {
  const { signal } = options;

  if (signal?.aborted) {
    throw new DOMException('The operation was aborted.', 'AbortError');
  }

  signal?.throwIfAborted?.();

  if (!dashboardUuid) {
    const error = new Error('Missing dashboard uuid');
    error.code = 'DASHBOARD_MISSING';
    throw error;
  }
  return {
    ...DASHBOARD_LAYOUT,
    data: {
      ...DASHBOARD_LAYOUT.data,
      dashboard_uuid: dashboardUuid,
    },
  };
};
